<template>
  <div class="body mobile">
    <!-- Header -->
    <section class="header">
      <div class="flexH width">
        <a class="icon iconButton third" @click.prevent="goBack">
          <font-awesome-icon
            icon="fa-solid fa-chevron-left"
            size="lg"
          ></font-awesome-icon>
        </a>
      </div>
      <span class="fL nowrap font-bold font-white">{{ $t('limited-time-mission.title', '決戰BMI要你走7000') }}</span>
      <div class="flexH width right"></div>
    </section>

    <!-- Main Content -->
    <div class="main mission-content" :style="{ backgroundImage: `url(${require('@/assets/icon/uide/LimitedTimeMission-Stpes-Detail-BG.svg')})` }">
      <div class="content-wrapper">
        <!-- Title Section -->
        <div class="title-section">
          <img 
            :src="require('@/assets/icon/uide/LimitedTimeMission-Stpes-Detail-Title.svg')" 
            alt="限時任務"
            class="title-image"
          />
        </div>

        <div class="activity-section">
          <div class="activity-header">
            <img 
              :src="require('@/assets/icon/uide/LimitedTimeMission-Stpes-Detail-icon.svg')" 
              alt="icon"
              class="activity-icon"
            />
            <span class="activity-title fXL">{{ $t('limited-time-mission.detail.title', '活動相關連結') }}</span>
          </div>
          
          <button class="activity-button fM" @click.prevent="linkClickHandler(urls.limitedQA)">
            {{ $t('limited-time-mission.detail.btn1', '活動Q&A') }}
          </button>
          
          <button class="activity-button fM" @click.prevent="linkClickHandler(urls.limitedDailyMission)">
            {{ $t('limited-time-mission.detail.btn2', '每日7000步挑戰報名') }}
          </button>
          
          <button class="activity-button fM" @click.prevent="linkClickHandler(urls.limitedBmiMissionSignup)">
            {{ $t('limited-time-mission.detail.btn3', 'BMI減重挑戰報名') }}
          </button>

          <button class="activity-button fM" @click.prevent="linkClickHandler(urls.limitedBmiMissionUpload)">
            {{ $t('limited-time-mission.detail.btn4', 'BMI減重挑戰-後測資料上傳') }}
          </button>

          <button class="activity-button fM" @click.prevent="linkClickHandler(urls.limitedMeasureHospital)">
            {{ $t('limited-time-mission.detail.btn5', '合作量測醫療院所名單') }}
          </button>
        </div>

        <p class="text-center fS pb-5">
          {{ $t('limited-time-mission.detail.service-phone', '客服電話：04-24620612 #24 劉小姐') }}
          <br />
          {{ $t('limited-time-mission.detail.service-time', '電話諮詢時間：週一至週五 09:00–17:00') }}
        </p>
      </div>
    </div>
    
    <!-- Popup Modal for External Links -->
    <LeaveDialog :show="isLeaveModalVisible" :url="nextUrl" @close="closeLeaveModal" />
  </div>
</template>

<script>
import LeaveDialog from "@/components/Dialog/LeaveDialog.vue";
import urls from "@/mixins/urls.js";

export default {
  name: 'LimitedTimeMissionDetail',
  mixins: [urls],
  components: {
    LeaveDialog
  },
  data() {
    return {
      nextUrl: '',
      isLeaveModalVisible: false
    }
  },
  methods: {
    goBack() {
      this.$router.go(-1);
    },
    linkClickHandler(url) {
      this.openLeaveModal();
      this.nextUrl = url;
    },
    openLeaveModal() {
      this.isLeaveModalVisible = true;
    },
    closeLeaveModal() {
      this.isLeaveModalVisible = false;
    }
  }
}
</script>

<style lang="scss" scoped>
.body.fixed .main.mission-content {
  position: relative;
  padding: 50px 0 10rem 0;
  z-index: 1;
  margin-top: 0;
  min-height: 100vh;
  background-color: linear-gradient(180deg, #E8E0FF 0%, #F5F2FF 100%);
  overflow-x: hidden;
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center bottom;
  background-attachment: initial;

  @media (min-width: 480px) {
    padding-bottom: 11rem;
  }

  @media (min-width: 576px) {
    padding-bottom: 15rem;
  }

  @media (min-width: 768px) {
    padding-bottom: 17rem;
  }
}

.content-wrapper {
  padding: 0 20px;
}

.title-section {
  text-align: center;
  padding: 45px 0 0 0;
  margin-bottom: 25px;
}

.title-image {
  width: 200px;
  height: auto;
}

.activity-section {
  background: rgba(255, 255, 255, 0.95);
  border-radius: 20px;
  padding: 24px 20px;
  margin: 0 15px 35px 15px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
}

.activity-section {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.activity-header {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 20px;
}

.activity-icon {
  width: 28px;
  height: 28px;
  margin-right: 10px;
}

.activity-title {
  font-weight: 700;
  font-style: normal;
  color: var(--k1);
  letter-spacing: 0.3px;
}

.activity-button {
  width: 100%;
  box-sizing: border-box;
  padding: 1rem;
  border-radius: 20px;
  font-weight: 500;
  font-style: normal;
  background: var(--k1);
  color: white;
  border: none;
  cursor: pointer;
  transition: all 0.3s ease;
  margin: 0 auto 0.875rem;
  box-shadow: 0px 4px 4px 0px #00000040;
}

.activity-button:active {
  background: #5B1FE5;
  transform: translateY(1px);
  box-shadow: none;
}
</style>

<style src="@/assets/css/app.css"></style>
<style src="@/assets/css/unique.css"></style>
